import { types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
import { dateToFormat } from 'src/utils/date';
const getResidentBalanceByResidencyAsync = createAsync(body => {
  return async function getResidentBalanceByResidency(options) {
    const resp = await api.Resident.getResidentBalanceByResidency(body, options);
    this.setResidentBalance(resp.response);
    return resp;
  };
});
const getAccountBalanceAsync = createAsync(body => {
  return async function getAccountBalance(options) {
    const resp = await api.Resident.getAccountBalance(body, options);
    this.setResidentBalance(resp.response);
    return resp;
  };
});
const ResidentBalance = types.model({
  balance: types.string,
  payments: types.string,
  currentBalance: types.string,
  lastEstimatedStatement: types.string,
  amountDueDateOnly: types.string,
  lastPaymentReceivedAtDateOnly: types.string,
  accountBalanceStatus: types.string
});
const ResidentBalanceInitialData = {
  lastPaymentReceivedAtDateOnly: 'xx/xx/xxxx',
  amountDueDateOnly: 'xx/xx/xxxx',
  balance: 'xx.xx',
  currentBalance: 'xx.xx',
  lastEstimatedStatement: 'xx.xx',
  payments: 'xxx',
  accountBalanceStatus: 'Ok'
};
const ResidentStore = types.model('ResidentStore', {
  getAccountBalanceAsync,
  getResidentBalanceByResidencyAsync,
  residentBalance: types.optional(ResidentBalance, ResidentBalanceInitialData)
}).actions(store => ({
  setResidentBalance(data) {
    try {
      Object.keys(data).forEach(key => {
        store.residentBalance[key] = "".concat(data[key]);
      });
      store.residentBalance.amountDueDateOnly = dateToFormat(store.residentBalance.amountDueDateOnly);
      store.residentBalance.lastPaymentReceivedAtDateOnly = dateToFormat(store.residentBalance.lastPaymentReceivedAtDateOnly);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
}));
export const resident = types.optional(ResidentStore, {});